// extracted by mini-css-extract-plugin
module.exports = {"button-default":"ButtonFavorite_button-default__FdT0t","button-active":"ButtonFavorite_button-active__sRjcb"};